import { createTheme } from '@material-ui/core/styles';

// https://stackoverflow.com/questions/60531601/how-can-i-customize-the-padding-in-a-material-ui-autocomplete-control

const theme = createTheme({
    overrides: {
        MuiInputBase: {
            input: {
                color: '#2574A9', // if you also want to change the color of the input, this is the prop you'd use
                fontFamily: 'Open Sans bold',
            },
        },
        MuiInputLabel: {
            // Label autocomplete
            outlined: {
                '.MuiAutocomplete-root &:not(.MuiInputLabel-shrink)': {
                    color: 'E1E3E7',
                    fontFamily: 'Open Sans bold',
                },
            },
        },
        MuiOutlinedInput: {
            root: {
                fontFamily: 'Open Sans bold',
                '& $notchedOutline': {
                    borderColor: '#E1E3E7',
                    borderWidth: '2px',
                },
                '&:hover $notchedOutline': {
                    borderColor: '#E1E3E7',
                    borderWidth: '2px',
                },
                '&$focused $notchedOutline': {
                    borderColor: '#E1E3E7',
                    borderWidth: '2px',
                },
            },
        },
        MuiFormLabel: {
            root: {
                color: '#4F7793',
                fontFamily: 'Open Sans',
            },
        },
        MuiFormControlLabel: {
            root: {
                // Radio text color
                color: '#4F7793',
                fontFamily: 'Open Sans',
            },
        },
        MuiRadio: {
            root: {
                // main color
                color: '#4F7793',
                fontSize: '50px',
                fontFamily: 'Open Sans bold',
            },
            colorSecondary: {
                // unchecked radio color
                color: '#4F7793',
                // Checked radio color
                '&$checked': {
                    color: '#3399DB',
                },
            },
        },
        MuiCheckbox: {
            root: {
                // main color
                color: '#4F7793',
                fontSize: '50px',
                fontFamily: 'Open Sans bold',
            },
            colorSecondary: {
                // unchecked radio color
                color: '#4F7793',
                // Checked radio color
                '&$checked': {
                    color: '#3399DB',
                },
            },
        },
    },
    palette: {
        primary: {
            main: '#2574a9',
            dark: '#00abcc',
            light: '#d9f6f7',
            contrastText: '#fff',
        },
        error: {
            main: '#eb4c37',
            dark: '#b53b29',
            light: '#ff7460',
            contrastText: '#fff',
        },
    },
    typography: {
        fontFamily: ['Open Sans Regular', 'Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
        fontWeightLight: 300,
        fontWeightMedium: 400,
        fontWeightBold: 700,
        h1: {
            fontSize: '40px',
            letterSpacing: '2px',
            textTransform: 'uppercase',
            fontFamily: "'Open Sans Light', sans-serif",
            textShadow: '1px 1px 1px #fff',
        },
        // TODO : h2,h5,h6 n'apparaissent pas dans la maquette (ils sont donc inventés)
        h2: {
            fontSize: '30px',
            letterSpacing: '1px',
            textTransform: 'uppercase',
            fontFamily: "'Open Sans SemiBold', sans-serif",
        },
        h3: {
            fontSize: '22px',
            letterSpacing: '0.5px',
            textTransform: 'uppercase',
            fontFamily: "'Open Sans Bold', sans-serif",
        },
        h4: {
            fontSize: '17px',
            fontFamily: "'Open Sans SemiBold', sans-serif",
            textTransform: 'uppercase',
        },
    },
});

export default theme;
